import React from "react";
import shallowequal from "shallowequal";
import filter from "../../filter";
import {executeQuery} from "../../requests/executeQuery";
import {renderPrintFooter} from '../../utils';
import {TEXAS_MARKET_TRANSACTIONS} from '../../consts/queries';
import MarketReport from "../MarketReport";
import { reportTypes } from "../../consts/consts";

export default class MarketTransactionBreakdown extends MarketReport {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`});
        this.fetch(this.props.location.query);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
        window.history.replaceState(null, '');
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    fetch(q) {
        const query = {...q};
        const queryPrevYear = {...q};

        const baseDate = query.BASE_MAX ? new Date(query.BASE_MAX) : query.BASE_MIN ? new Date(query.BASE_MIN) : new Date();
        const baseMonth = baseDate.getMonth()+1;
        const baseDay = baseDate.getDate();
        let year = baseDate.getFullYear().toString(), prevYear = year - 1;

        if (query.COMPARISON_MIN || query.COMPARISON_MAX) {
            delete query.COMPARISON_MIN;
            delete query.COMPARISON_MAX;
            delete queryPrevYear.BASE_MIN;
            delete queryPrevYear.BASE_MAX;
        }
        else if (query.BASE_MIN || query.BASE_MAX) {
            delete queryPrevYear.BASE_MIN;
            delete queryPrevYear.BASE_MAX;
            queryPrevYear.COMPARISON_MIN =`01/01/${prevYear}`;
            queryPrevYear.COMPARISON_MAX =`${baseMonth}/${baseDay}/${prevYear}`;
        }
        else {
            query.BASE_MIN = `01/01/${year}`;
            query.BASE_MAX = `12/31/${year}`;
            queryPrevYear.COMPARISON_MIN =`01/01/${prevYear}`;
            queryPrevYear.COMPARISON_MAX =`12/31/${prevYear}`;
        }

        const optionsSTNL = filter({...query, TYPE: 'STNL'}, 'market-transaction-breakdown');
        const optionsPrevYearSTNL = filter({...queryPrevYear, TYPE: 'STNL'}, 'market-transaction-breakdown');
        const optionsMT = filter({...query, TYPE: 'MT'}, 'market-transaction-breakdown');
        const optionsPrevYearMT = filter({...queryPrevYear, TYPE: 'MT'}, 'market-transaction-breakdown');

        const requests = [
            executeQuery({queryName: TEXAS_MARKET_TRANSACTIONS, options: optionsSTNL}),
            executeQuery({queryName: TEXAS_MARKET_TRANSACTIONS, options: optionsPrevYearSTNL}),
            executeQuery({queryName: TEXAS_MARKET_TRANSACTIONS, options: optionsMT}),
            executeQuery({queryName: TEXAS_MARKET_TRANSACTIONS, options: optionsPrevYearMT}),
        ];

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].data && Array.isArray(res[0].data) &&
                res[1] && res[1].data && Array.isArray(res[1].data) &&
                res[2] && res[2].data && Array.isArray(res[2].data) &&
                res[3] && res[3].data && Array.isArray(res[3].data)) {

                const transactions = [];
                transactions.STNL = MarketTransactionBreakdown.buildTableData({data: res[0].data[0], prevData: res[1].data[0], type: 'STNL'});
                transactions.MT = MarketTransactionBreakdown.buildTableData({data: res[2].data[0], prevData: res[3].data[0], type: 'MT'});

                this.setState({
                    query,
                    year: year,
                    previousYear: prevYear,
                    transactions
                });
                return;
            }

            this.setState({
                query,
                year: year,
                previousYear: prevYear
            });
        });
    }

    render() {
        const {query, transactions, year, previousYear, isPrint, printBackground} = this.state;
        const reportType = reportTypes.MarketTransactionBreakdown;

        return (
            <div className='MarketReport'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketReport.renderMarketTable({reportType:reportType, data: transactions.MT, type: 'Multi-Tenant', market: query.MARKET, year, previousYear, baseMin: query.BASE_MIN, baseMax: query.BASE_MAX})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketReport.renderMarketTable({reportType:reportType, data: transactions.STNL, type: 'Single-Tenant', market: query.MARKET, year, previousYear, baseMin: query.BASE_MIN, baseMax: query.BASE_MAX})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        )
    }
}